export default {
    name: 'Nama',
    tel: 'Telepon',
    save: 'Simpan',
    confirm: 'Konfirmasi',
    cancel: 'Batal',
    delete: 'Hapus',
    complete: 'Selesai',
    loading: 'Memuat...',
    telEmpty: 'Harap isi nomor telepon',
    nameEmpty: 'Silakan isi nama',
    nameInvalid: 'Format nama tidak valid',
    confirmDelete: 'Apakah Anda yakin ingin menghapus?',
    telInvalid: 'Nomor telepon salah format',
    vanCalendar: {
        end: 'Akhir',
        start: 'Mulai',
        title: 'Kalender',
        startEnd: 'Mulai/Akhir',
        weekdays: ['minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'],
        monthTitle: function monthTitle(year, month) {
            return year + "/" + month;
        },
        rangePrompt: function rangePrompt(maxRange) {
            return "Pilih tidak lebih dari " + maxRange + " hari";
        }
    },
    vanCascader: {
        select: 'Pilih'
    },
    vanContactCard: {
        addText: 'Tambahkan info kontak'
    },
    vanContactList: {
        addText: 'Tambahkan kontak baru'
    },
    vanPagination: {
        prev: 'Sebelumnya',
        next: 'Berikutnya'
    },
    vanPullRefresh: {
        pulling: 'Tarik untuk menyegarkan...',
        loosing: 'Loose untuk menyegarkan...',
    },
    vanSubmitBar: {
        label: 'Jumlah:',
    },
    vanCoupon: {
        unlimited: 'Tidak terbatas',
        discount: discount => `${discount * 10}% off`,
        condition: condition => `Setidaknya ${condition}`,
    },
    vanCouponCell: {
        title: 'Kupon',
        tips: 'Tidak ada kupon',
        count: count => `Anda memiliki kupon ${count}`,
    },
    vanCouponList: {
        empty: 'Tidak ada kupon',
        exchange: 'Tukar',
        close: 'Tutup',
        enable: 'Tersedia',
        disabled: 'Tidak tersedia',
        placeholder: 'Kode kupon'
    },
    vanAddressEdit: {
        area: 'Daerah',
        postal: 'Kode Pos',
        areaEmpty: 'Silakan pilih area penerima',
        addressEmpty: 'Alamat tidak boleh kosong',
        postalEmpty: 'Kode pos salah',
        defaultAddress: 'Atur sebagai alamat utama',
        telPlaceholder: 'Telepon',
        namePlaceholder: 'Nama',
        areaPlaceholder: 'Wilayah'
    },
    vanAddressEditDetail: {
        label: 'Alamat',
        placeholder: 'Alamat'
    },
    vanAddressList: {
        add: 'Tambahkan alamat baru'
    }
};